import { createApp } from 'vue'
import Main from './App.vue'

import './style.scss'
import './print.scss'

import utils from './utils.js'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import { 
    faPen,
    faTrashCan,
    faSignOutAlt,
    faSave,
    faUsers,
    faUserGear,
    faTimes,
    faPlus,
    faClockRotateLeft,
    faUpload,
    faFolder,
    faFileLines,
    faPhone,
    faCog,
    faBusinessTime,
    faFolderOpen,
    faMagnifyingGlass,
    faCalendar,
    faCalendarDays,
    faUser,
    faCircleInfo,
    faFile,
    faTemperatureArrowUp,
    faBuilding,
    faMapLocation,
    faListUl,
    faFilterCircleXmark,
    faKey,
    faLocationDot,
    faUserPlus,
    faCalendarWeek,
    faEyeSlash,
    faEye,
    faPhoneVolume,
    faMinus,
    faPaperclip,
    faCamera,
    faCircle,
    faCopy,
    faLock,
    faPenRuler,
    faCloud,
    faFileImport,
    faBell,
    faFileInvoice,
    faLockOpen,
    faShare,
    faBoxesStacked,
    faArrowsUpDown,
    faAngleDown,
    faThumbTack,
    faPenToSquare
} from '@fortawesome/free-solid-svg-icons'

import { 
    faCircleCheck,
    faCircleQuestion,
    faCircleXmark,
    faSquare,
    faSquareCheck
} from '@fortawesome/free-regular-svg-icons'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* add icons to the library */
library.add(
    faPen,
    faTrashCan,
    faSignOutAlt,
    faSave,
    faUsers, 
    faUserGear,
    faTimes,
    faPlus,
    faClockRotateLeft,
    faUpload,
    faFolder,
    faPhone,
    faCog,
    faBusinessTime,
    faFolderOpen,
    faMagnifyingGlass,
    faCalendar,
    faCalendarDays,
    faUser,
    faCircleInfo,
    faFile,
    faTemperatureArrowUp,
    faBuilding,
    faMapLocation,
    faFileLines,
    faListUl,
    faFilterCircleXmark,
    faKey,
    faLocationDot,
    faUserPlus,
    faCalendarWeek,
    faEye,
    faEyeSlash,
    faPhoneVolume,
    faMinus,
    faPaperclip,
    faCamera,
    faCircle,
    faCopy,
    faLock,
    faPenRuler,
    faCloud,
    faFileImport,
    faSquare,
    faSquareCheck,
    faBell,
    faCircleCheck,
    faCircleXmark,
    faCircleQuestion,
    faFileInvoice,
    faLockOpen,
    faShare,
    faBoxesStacked,
    faArrowsUpDown,
    faAngleDown,
    faThumbTack,
    faPenToSquare
)

//multiselect
import Multiselect from 'vue-multiselect'

//traduzioni multiselect
Multiselect.props.selectLabel.default = ''
Multiselect.props.selectGroupLabel.default = ''
Multiselect.props.selectedLabel.default = 'Selezionato'
Multiselect.props.deselectLabel.default = ''
Multiselect.props.deselectGroupLabel.default = ''
Multiselect.mixins[0].props.placeholder.default = 'Seleziona elemento'
Multiselect.mixins[0].props.tagPlaceholder.default = ''

//v-calendar
import VCalendar from '@angelblanco/v-calendar'

//OpenLayersMap
//import OpenLayersMap from 'vue3-openlayers'
//import 'vue3-openlayers/dist/vue3-openlayers.css'

//VueGoogleMaps
import VueGoogleMaps from '@fawmi/vue-google-maps'

//FileList
import FileList from './components/FileList'

//Revisions
import Revisions from './components/Revisions'

//InputDate
import InputDate from './components/InputDate'

//InputText
import InputText from './components/InputText'

//InputTextarea
import InputTextarea from './components/InputTextarea'

//InputSelect
import InputSelect from './components/InputSelect'

//InfoButton
import InfoButton from './components/InfoButton'

//MapGoogle
import MapGoogle from './components/MapGoogle'

//Pagination
import Pagination from './components/Pagination'

//ClientHeading
import ClientHeading from './components/ClientHeading'

//ClientInfo
import ClientInfo from './components/ClientInfo'

//WeekCalendar
import WeekCalendar from './components/WeekCalendar'

//Modal
import Modal from './components/Modal'

//AppointmentCalendar
import AppointmentCalendar from './components/AppointmentCalendar'

//CallCalendar
import CallCalendar from './components/CallCalendar'

//AppointmentLinkCalendar
import AppointmentLinkCalendar from './components/AppointmentLinkCalendar'

//Timeline
import Timeline from './components/Timeline'

//ImplantTable
//import ImplantTable from './components/ImplantTable'

//ImplantInfo
import ImplantInfo from './components/ImplantInfo'

//Sub
import Sub from './components/implant-form/_sub'

//Transfer
import Transfer from './components/implant-form/_transfer'

//FormBrand
import FormBrand from './components/FormBrand'

//FormModel
import FormModel from './components/FormModel'

//OperationLabel
import OperationLabel from './components/OperationLabel'

//DirectLabel
import DirectLabel from './components/DirectLabel'

import router from './router'

import store from './store'

// PAUSA TEMPORANEA: controllo modifiche non salvate disattivato per investigazione.
// window.addEventListener('beforeunload', (event) => {
//     const currentPath = router.currentRoute?.value?.path || ''
//     const currentFormName = utils.getGuardedFormNameByPath(currentPath)
//     if (currentFormName && utils.hasUnsavedForms(store, [currentFormName])) {
//         event.preventDefault()
//         event.returnValue = ''
//     }
// })

const app = createApp(Main)

import axios from 'axios'
axios.defaults.baseURL = import.meta.env.VITE_SERVER


axios.defaults.withCredentials = true
app.config.globalProperties.$http = axios

//debounce
import debounce from 'lodash.debounce'
app.config.globalProperties.$debounce = debounce

//directives
import directives from './directives'

//utils
app.config.globalProperties.$fullname = utils.fullname
app.config.globalProperties.$fulladdress = utils.fulladdress
app.config.globalProperties.$clientName = utils.clientName
app.config.globalProperties.$image = utils.useImage
app.config.globalProperties.$placeName = utils.placeName
app.config.globalProperties.$implantName = utils.implantName
app.config.globalProperties.$generatorName = utils.generatorName
app.config.globalProperties.$generatorNameReg = utils.generatorNameReg
app.config.globalProperties.$implantNameOperation = utils.implantNameOperation

app
    .component('font-awesome-icon', FontAwesomeIcon)
    .component('multiselect', Multiselect)
    .use(VCalendar, {
        locales: {
            'it-IT': {
                firstDayOfWeek: 2,
                masks: {
                    L: 'DD/MM/YYYY',
                }
            }
        }})
    .component('FileList', FileList)
    .component('Revisions', Revisions)
    .component('InputDate', InputDate)
    .component('InputText', InputText)
    .component('InputTextarea', InputTextarea)
    .component('InputSelect', InputSelect)
    .component('InfoButton', InfoButton)
    .component('MapGoogle', MapGoogle)
    .component('Pagination', Pagination)
    .component('ClientHeading', ClientHeading)
    .component('ClientInfo', ClientInfo)
    .component('WeekCalendar', WeekCalendar)
    .component('Modal', Modal)
    .component('AppointmentCalendar', AppointmentCalendar)
    .component('CallCalendar', CallCalendar)
    .component('AppointmentLinkCalendar', AppointmentLinkCalendar)
    .component('Timeline', Timeline)
    //.component('ImplantTable', ImplantTable)
    .component('ImplantInfo', ImplantInfo)
    .component('Sub', Sub)
    .component('Transfer', Transfer)
    .component('FormBrand', FormBrand)
    .component('FormModel', FormModel)
    .component('OperationLabel', OperationLabel)
    .component('DirectLabel', DirectLabel)
    .directive('disableAll', directives.disableAll)
    .use(router)
    .use(store)
    //.use(OpenLayersMap)
    .use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyD6s89QcTFRruR7ySz4m6KC4xT9PkravNM',//legambiente
            language: 'it',
            v: 3.59
        },
    })
    .mount('#app')
